<template>
  <v-tooltip :top="!bottom" :bottom="bottom">
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="label && !icon"
        :text="isText"
        color="primary"
        @click="event(object, $event)"
        v-on="on || on1"
        :loading="loading"
        :x-small="mobile"
        :small="!mobile"
        :class="{ 'pa-2': reduceMagins, 'ml-2': margin, 'mr-3': marginRight }"
        >{{ label }}</v-btn
      >

      <v-btn
        v-if="label && icon"
        :text="isText"
        color="primary"
        @click="event(object, $event)"
        v-on="on || on1"
        :loading="loading"
        :x-small="mobile"
        :small="!mobile"
        :class="{ 'pa-2': reduceMagins, 'ml-2': margin, 'mr-3': marginRight }"
        >{{ label }}
        <v-icon>{{ icon }}</v-icon>
      </v-btn>

      <v-btn
        v-if="icon && !label"
        :text="isText"
        color="blue darken-2"
        @click="event(object, $event)"
        v-on="on || on1"
        :loading="loading"
        :x-small="mobile"
        :small="!mobile"
        :class="{ 'pa-2': reduceMagins, 'mr-3': marginRight }"
        dark
      >
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span style="max-width: 200px; word-wrap: break-word; display: block">{{
      message
    }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    label: String,
    icon: String,
    message: String,
    event: Function,
    loading: Boolean,
    on1: String,
    object: Object,
    mobile: Boolean,
    isText: Boolean,
    bottom: Boolean,
    reduceMagins: Boolean,
    margin: Boolean,
    marginRight: Boolean,
  },
};
</script>